<ng-container>
  @if (displayError) {
  <mat-icon class="running-with-errors" (click)="openTooManyResultsBox()">
    running_with_errors</mat-icon
  >
  }
  <div class="hold-cell active" [ngClass]="{ active: speechBoxOpened }">
    <mat-icon
      class="material-symbols-outlined"
      color="primary"
      [matTooltip]="hold ? 'ON HOLD ' + this.reason : ''"
      matToolTipDisabled="!hold"
      [ngClass]="hold ? 'task-on-hold' : 'add_circle'"
      (click)="openSpeechBox()"
    >
      {{ hold ? '' : 'add_circle' }}
    </mat-icon>
  </div>
</ng-container>
